import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Twosixseaterbus() {



  const cardData =
  {
    keyword: '26 Seater Bus on Rent in Pune',
    heading: 'Sanavi Travels: 26 Seater Bus on Rent in Pune',
    headingDescription: 'Sanavi Travels offers reliable 26 Seater Bus on Rent in Pune, providing safe, comfortable, and convenient transportation for medium-sized groups, corporate events, school trips, family outings, and outstation travel. Our fleet of well-maintained AC and non-AC 26-seater buses ensures ample seating, smooth rides, and a hassle-free journey for all passengers. With professional drivers, flexible full-day and outstation rental packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide convenient pickup and drop services across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, making us a trusted choice for group transportation. Choose Sanavi Travels for trusted 26 seater bus rental services in Pune, delivering comfort, safety, and a seamless travel experience for every occasion.',

    top: 'Top Places to Visit in Pune with Sanavi Travels',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is Pune’s iconic 18th-century fort built by the Peshwas, featuring massive stone walls, grand gateways like Delhi Darwaza, and spacious courtyards. Though partly destroyed by fire, it stands as a symbol of Maratha heritage and valor. The evening light-and-sound show narrates Pune’s royal history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace is a historic monument tied to India’s freedom movement, where Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned. It now houses a museum displaying Gandhi’s personal artifacts and documents amidst serene gardens, making it a significant heritage site."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered Ganesh temple. The idol, adorned with gold ornaments, draws thousands of devotees daily. Ganesh Chaturthi sees grand celebrations, music, and cultural events, highlighting its spiritual and social significance."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, situated on a hilltop near Pune, is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Shivaji Maharaj. Visitors can trek or drive to explore the fort, enjoy scenic Sahyadri views, and savor local delicacies like pithla-bhakri."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from basalt rock, it features monolithic pillars and a serene sanctum. Despite its urban location, it offers peace, meditation, and a glimpse into ancient craftsmanship."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts including traditional ornaments, musical instruments, and household antiques. The recreated Mastani Mahal is a highlight, offering cultural and historical insights into India’s heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views after climbing 103 steps. The hilltop temple complex, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era and includes smaller shrines and a museum."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global center for meditation, wellness therapies, and mindfulness. Spread across landscaped gardens, it attracts visitors seeking relaxation, rejuvenation, and spiritual growth."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. With arched bridges, water streams, and manicured lawns, it is perfect for morning walks, family outings, and photography."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot near Pune. Surrounded by hills, it offers scenic views, especially during monsoon. Visitors enjoy picnics, sunset views, and local snacks, making it a favorite weekend destination."
  }
]
,



"services": [
  {
    "name": "26 Seater Bus on Rent in Pune",
    "description": "26 Seater Bus on Rent in Pune provides comfortable and spacious buses for medium-sized groups, ideal for family outings, corporate trips, weddings, school excursions, and local tours. Fully air-conditioned with reclining seats, wide legroom, and ample luggage space, these buses ensure a relaxed and enjoyable journey. Experienced chauffeurs manage routes, traffic, and timing, allowing passengers to focus on their trip. Flexible pickup and drop-off locations and customizable itineraries make it perfect for city travel, weekend getaways, and short or long-distance trips from Pune."
  },
  {
    "name": "26 Seater Bus Hire Pune",
    "description": "26 Seater Bus Hire Pune offers organized rental services for schools, colleges, corporate teams, wedding guests, and social groups. Air-conditioned and well-maintained buses feature comfortable seating and sufficient luggage capacity. Professional drivers ensure safe, timely, and hassle-free travel, supporting multi-stop trips and flexible schedules. Ideal for day trips, weekend tours, and short-distance journeys, this service combines convenience, reliability, and comfort for medium-sized groups traveling from Pune."
  },
  {
    "name": "AC 26 Seater Bus Pune",
    "description": "AC 26 Seater Bus Pune ensures a refreshing and comfortable ride for medium-sized groups with fully air-conditioned interiors, spacious seating, and ample legroom. Suitable for family trips, corporate travel, weddings, school tours, and sightseeing excursions, this service emphasizes comfort, safety, and convenience. Experienced chauffeurs handle navigation, traffic, and scheduling, allowing passengers to enjoy stress-free travel. Flexible booking options and customizable itineraries make it perfect for day trips, short excursions, and weekend getaways from Pune."
  },
  {
    "name": "Luxury 26 Seater Bus Pune",
    "description": "Luxury 26 Seater Bus Pune provides a premium travel experience for medium-sized groups, featuring elegant interiors, comfortable seating, air-conditioning, and modern amenities. Ideal for VIP transport, corporate events, weddings, and exclusive group tours, this service ensures style, comfort, and punctuality. Professional chauffeurs manage navigation, traffic, and schedules efficiently, delivering a smooth and safe journey. Flexible pickup and drop-off points and customizable travel plans make it suitable for city tours, short trips, or outstation travel from Pune."
  },
  {
    "name": "Wedding 26 Seater Bus Pune",
    "description": "Wedding 26 Seater Bus Pune specializes in transporting guests to wedding ceremonies, receptions, and related events comfortably and safely. Buses are air-conditioned, spacious, and equipped with comfortable seats and luggage storage for gifts and personal items. Experienced chauffeurs ensure timely arrivals, smooth driving, and coordinated multi-stop travel. Ideal for family weddings, destination weddings, and multi-location celebrations, this service offers convenience, reliability, and comfort for guests traveling together."
  },
  {
    "name": "Corporate 26 Seater Bus Pune",
    "description": "Corporate 26 Seater Bus Pune provides reliable transport for corporate events, employee transfers, team outings, and conferences. Buses feature air-conditioning, spacious seating, and luggage capacity for employee needs. Professional chauffeurs ensure safe, timely, and smooth travel, managing traffic and route planning efficiently. Flexible itineraries, multi-stop trips, and convenient pickup/drop-off locations make this service suitable for corporate travel, business retreats, and short or long-distance trips from Pune."
  },
  {
    "name": "Outstation 26 Seater Bus Pune",
    "description": "Outstation 26 Seater Bus Pune is designed for intercity and long-distance travel for medium-sized groups. Buses are air-conditioned, spacious, and equipped with reclining seats and luggage storage. Experienced drivers manage highways, route planning, and traffic, ensuring a safe and smooth journey. Suitable for family trips, corporate tours, school outings, and tourist excursions, this service offers flexible routes and schedules for medium-sized groups traveling outside Pune."
  },
  {
    "name": "Affordable 26 Seater Bus Pune",
    "description": "Affordable 26 Seater Bus Pune provides cost-effective transport solutions for families, corporate teams, schools, and small social groups without compromising on comfort or safety. Buses are clean, air-conditioned, and spacious with sufficient seating and luggage space. Professional chauffeurs ensure punctual pickups, smooth driving, and safe arrivals. Flexible scheduling, multi-stop itineraries, and customizable routes make it ideal for day trips, weekend tours, and short-distance travel from Pune."
  },
  {
    "name": "Chauffeur Driven 26 Seater Bus",
    "description": "Chauffeur Driven 26 Seater Bus offers stress-free and comfortable travel for medium-sized groups, with professional drivers handling navigation, traffic, and scheduling. Buses are air-conditioned, spacious, and equipped with comfortable seating and luggage storage. Suitable for weddings, corporate events, school excursions, tourist trips, and family outings, this service ensures a safe, smooth, and enjoyable journey. Flexible booking options and multi-stop itineraries allow passengers to plan trips according to their needs and preferences."
  },
  {
    "name": "Best 26 Seater Bus Pune",
    "description": "Best 26 Seater Bus Pune provides premium buses for medium-sized groups seeking comfort, safety, and reliability. Fully air-conditioned with spacious seating and luggage space, these buses are ideal for weddings, corporate events, family trips, school tours, and leisure excursions. Professional chauffeurs ensure punctual pickups, smooth driving, and safe journeys. Flexible pickup, drop-off, and itinerary options make this service suitable for day trips, weekend getaways, or long-distance travel from Pune."
  },
  {
    "name": "Pune Bus Booking Service",
    "description": "Pune Bus Booking Service enables easy online reservation of 26-seater buses for weddings, corporate events, school trips, family outings, and tourist excursions. Users can select bus type, travel dates, pickup and drop-off locations, and itineraries with instant confirmation. Fully air-conditioned buses with professional chauffeurs ensure a comfortable, safe, and reliable journey. Flexible booking options, multi-stop trips, and customizable routes make it convenient for medium-sized groups traveling in and around Pune."
  },
  {
    "name": "Tourist 26 Seater Bus Pune",
    "description": "Tourist 26 Seater Bus Pune provides organized transportation for sightseeing, heritage tours, leisure trips, and city excursions for medium-sized groups. Buses are air-conditioned, spacious, and equipped with comfortable seating and luggage space. Professional chauffeurs manage routes, traffic, and stops efficiently, ensuring smooth and enjoyable travel. Suitable for families, school groups, corporate teams, and friends, this service offers flexibility, comfort, and reliability for medium-sized groups exploring Pune’s attractions."
  },
  {
    "name": "Event Bus Rental Pune",
    "description": "Event Bus Rental Pune offers dependable transportation for weddings, corporate gatherings, social events, and parties for medium-sized groups. Buses are air-conditioned, comfortable, and provide seating and luggage storage. Professional drivers ensure timely pickups, smooth driving, and coordinated multi-location travel. Ideal for weddings, corporate events, family gatherings, and leisure trips, this service emphasizes safety, convenience, and comfort, delivering a stress-free travel experience for all passengers."
  },
  {
    "name": "Family Trip Bus Pune",
    "description": "Family Trip Bus Pune is perfect for medium-sized family outings, vacations, and leisure trips. The 26-seater buses offer air-conditioning, comfortable seating, and ample luggage space for personal belongings. Professional chauffeurs manage traffic, route planning, and scheduling to ensure a smooth, enjoyable journey. Flexible pickup, drop-off, and multi-stop itineraries make this service suitable for day trips, weekend getaways, or multi-day excursions from Pune."
  },
  {
    "name": "Group Travel Bus Pune",
    "description": "Group Travel Bus Pune specializes in transporting medium-sized groups for school trips, corporate events, weddings, and leisure tours. Buses are spacious, air-conditioned, and equipped with comfortable seating and luggage storage. Experienced chauffeurs ensure timely pickups, safe driving, and smooth journeys. Flexible booking options, customizable routes, and multi-stop itineraries provide a convenient and reliable travel experience for medium-sized groups within Pune and nearby destinations."
  }
],
"tableData": [
  ["26 Seater Bus on Rent in Pune", "26 Seater Bus Hire Pune"],
  ["AC 26 Seater Bus Pune", "Luxury 26 Seater Bus Pune"],
  ["Wedding 26 Seater Bus Pune", "Corporate 26 Seater Bus Pune"],
  ["Outstation 26 Seater Bus Pune", "Affordable 26 Seater Bus Pune"],
  ["Chauffeur Driven 26 Seater Bus", "Best 26 Seater Bus Pune"],
  ["Pune Bus Booking Service", "Tourist 26 Seater Bus Pune"],
  ["Event Bus Rental Pune", "Family Trip Bus Pune"],
  ["Group Travel Bus Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "26 Seater Bus on Rent in Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides 26-seater buses on rent in Pune, ideal for medium-sized group trips, corporate events, school excursions, and family outings."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced 26-seater buses, ensuring a comfortable and enjoyable journey in Pune."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with Pune routes, ensuring safe and timely transportation for medium-sized groups."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for 26-seater bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, route planning, and any last-minute changes for your 26-seater bus rental."
  },
  {
    "WhyChooseheading": "Flexible Rental Packages",
    "WhyChoosedescription": "Choose from hourly, half-day, full-day, or customized rental packages based on your group’s schedule and travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All 26-seater buses are thoroughly cleaned and sanitized before each trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for 26-seater bus rentals in Pune."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide 26-seater buses on rent in Pune?',
    answer: 'Yes, Sanavi Travels offers 26-seater buses for medium-sized group trips, corporate events, school excursions, and family outings in Pune.'
  },
  {
    question: 'How can I book a 26-seater bus in Pune?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'Are the 26-seater buses well-maintained and air-conditioned?',
    answer: 'Yes, all our 26-seater buses are clean, air-conditioned, and regularly serviced for a comfortable travel experience.'
  },
  {
    question: 'Are drivers experienced with Pune routes?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with Pune routes to ensure safe and timely transportation.'
  },
  {
    question: 'Can I rent the 26-seater bus for a few hours or a full day?',
    answer: 'Absolutely. We offer hourly, half-day, full-day, and custom packages to meet your travel requirements.'
  },
  {
    question: 'Are the buses sanitized before every trip?',
    answer: 'Yes, all 26-seater buses are thoroughly cleaned and sanitized before departure.'
  },
  {
    question: 'Is customer support available during the rental?',
    answer: 'Yes, our 24x7 customer support team is available throughout your 26-seater bus rental.'
  },
  {
    question: 'What payment options are available for 26-seater bus rentals?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is punctual service guaranteed for 26-seater bus rentals?',
    answer: 'Yes, Sanavi Travels ensures on-time pickups and reliable service for all 26-seater bus bookings in Pune.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Deshmukh',
    feedback: 'Booked a 26-seater bus for our school excursion. Spacious, clean, and the driver was very professional.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Rutuja Patil',
    feedback: 'Excellent 26-seater bus rental service. Comfortable ride, on-time service, and very helpful staff.',
    rating: 5
  }
];




































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "26 Seater Bus on Rent in Pune - Sanavi Travels",
  "description": "Hire 26 seater buses in Pune with Sanavi Travels. AC and luxury buses ideal for weddings, corporate events, outstation trips, family travel, group tours, events, and chauffeur-driven comfortable journeys.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};




  return (
    <div>

<Helmet>
  <title>
    26 Seater Bus on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book AC and luxury 26 seater buses in Pune with Sanavi Travels. Perfect for weddings, corporate events, outstation trips, family travel, group tours, events, and safe chauffeur-driven journeys."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/80.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Twosixseaterbus;